import React from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Tooltip } from 'react-tippy'
const LinkBoxNavBar = (props) => {
  const {
    children,
    icon,
    active,
    to = '',
    setNavsMenu,
    navsmenu,
    pending = null,
    step,
    label,
    ...rest
  } = props

  const LinkNav = ({ portrait = false }) => (
    <Link
      className={`text-lg 2xl:text-xl border border-[#618BCC10] flex gap-1 items-center py-[10px] pl-2 pr-1 bg-inherit hover:bg-[#618BCC] text-gray-900 hover:text-white transition-all duration-150 overflow-clip rounded-lg select-none ${active
        ? 'bg-[#618BCC] shadow-md border-[#618BCC10]'
        : ''
        }`}
      to={to}
      {...rest}
      // title={navsmenu ? label : ''}
      onClick={portrait ? () => setNavsMenu(!navsmenu) : null}
    >
      {pending === null ? (
        <>
          <FontAwesomeIcon
            icon={icon}
            className={`text-lg w-6 ${active ? 'text-white' : ''} rounded-md`}
          />
          <h4 className={`text-sm ${active ? 'text-white font-semibold text-shadow' : ' font-medium'}`}>{children}</h4>
        </>
      ) : (
        <div className="flex items-center justify-between w-full ">
          <h4 className={`text-sm ${active ? 'text-white font-semibold text-shadow' : ' font-medium'}`}>
            {
              step &&
              <span className={`font-bold w-7`}>
                {step}. {' '}
              </span>
            }
            {children}
          </h4>
          <span
            className={`text-xs px-1 py-0.5 ${pending === 0 ? 'bg-blue-700' : 'bg-red-500'
              } text-white ml-1 rounded-lg`}
          >
            {pending > 99 ? '99+' : pending}
          </span>
        </div>
      )}
    </Link>
  )

  return (
    <>
      <div>
        {
          navsmenu ?
            <Tooltip title={label} position="right-end" trigger="mouseenter">
              <LinkNav />
            </Tooltip>
            :
            <LinkNav />
        }
      </div>
      {/* <div className="hidden portrait:block">
        <LinkNav portrait={true} />
      </div>
      <div className="block portrait:hidden">
        <Tooltip title={children} position="right-end" trigger="mouseenter">
          <LinkNav />
        </Tooltip>
      </div> */}
    </>
  )
}

export default LinkBoxNavBar
